import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { DemensionAndWeightAppearanceTypeEnum } from "commons/enum/appearance-type";
import { InspectionOtherStandard } from "commons/enum/inspection";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { NumberText } from "share-components/atomics/number-text";
import { TextNoTranform } from "share-components/atomics/text-no-tranform";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
import { getLabelOfAppearanceType, getLabelOfOthersStandard } from "..";

export const DimensionWeightInformationTable = observer(() => {
  const {
    productManagement: { productDetail },
  } = useStores();
  return (
    <XTablePagination hidePagination>
      <TableHead>
        <TableRow>
          <TableCell align="center" colSpan={3}>
            Chiều dài <TextNoTranform>(mm)</TextNoTranform>
          </TableCell>
          <TableCell align="center" colSpan={3}>
            Chiều rộng <TextNoTranform>(mm)</TextNoTranform>
          </TableCell>
          <TableCell align="center" colSpan={3}>
            Chiều cao <TextNoTranform>(mm)</TextNoTranform>
          </TableCell>
          <TableCell align="center" colSpan={2}>
            Quy Cách Phẳng <TextNoTranform>(mm)</TextNoTranform>
          </TableCell>
          <TableCell align="center" colSpan={3}>
            Trọng Lượng SP <TextNoTranform>(gram)</TextNoTranform>
          </TableCell>
          <TableCell align="center" colSpan={2}>
            Ngoại quan
          </TableCell>
          <TableCell align="center" colSpan={2}>
            Tiêu chuẩn khác
          </TableCell>
          <TableCell align="center" colSpan={2}>
            Tiêu chuẩn toa gấp
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Chuẩn</TableCell>
          <TableCell>Trên</TableCell>
          <TableCell>Dưới</TableCell>
          <TableCell>Chuẩn</TableCell>
          <TableCell>Trên</TableCell>
          <TableCell>Dưới</TableCell>
          <TableCell>Chuẩn</TableCell>
          <TableCell>Trên</TableCell>
          <TableCell>Dưới</TableCell>
          <TableCell>Khổ giấy</TableCell>
          <TableCell>Chiều dài</TableCell>
          <TableCell>Chuẩn</TableCell>
          <TableCell>Trên</TableCell>
          <TableCell>Dưới</TableCell>
          <TableCell>Loại</TableCell>
          <TableCell>Mô tả</TableCell>
          <TableCell>Chọn</TableCell>
          <TableCell>Thêm</TableCell>
          <TableCell>Kích thước gấp</TableCell>
          <TableCell>Số lần gấp</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>
            {productDetail?.dimensionWeight?.lengthStandardDisplay}
          </TableCell>
          <TableCell>
            {productDetail?.dimensionWeight?.lengthUpperWithFactorNumberDisplay}
          </TableCell>
          <TableCell>
            {productDetail?.dimensionWeight?.lengthLowerWithFactorNumberDisplay}
          </TableCell>

          <TableCell>
            {productDetail?.dimensionWeight?.widthStandardDisplay}
          </TableCell>
          <TableCell>
            {productDetail?.dimensionWeight?.widthUpperWithFactorNumberDisplay}
          </TableCell>
          <TableCell>
            {productDetail?.dimensionWeight?.widthLowerWithFactorNumberDisplay}
          </TableCell>

          <TableCell>
            {productDetail?.dimensionWeight?.heightStandardDisplay || ""}
          </TableCell>
          <TableCell>
            {productDetail?.dimensionWeight
              ?.heightUpperWithFactorNumberDisplay || ""}
          </TableCell>
          <TableCell>
            {productDetail?.dimensionWeight
              ?.heightLowerWithFactorNumberDisplay || ""}
          </TableCell>
          <TableCell>
            <NumberText
              value={productDetail?.dimensionWeight?.planeSpecPaperSize}
              decimalScale={1}
              fixedDecimalScale={true}
            ></NumberText>
          </TableCell>
          <TableCell>
            <NumberText
              value={productDetail?.dimensionWeight?.planeSpecLength}
              decimalScale={1}
              fixedDecimalScale={true}
            ></NumberText>
          </TableCell>

          <TableCell>
            {productDetail?.dimensionWeight?.weightStandardDisplay || ""}
          </TableCell>
          <TableCell>
            {productDetail?.dimensionWeight
              ?.weightUpperWithFactorPercentDisplay || ""}
          </TableCell>
          <TableCell>
            {productDetail?.dimensionWeight
              ?.weightLowerWithFactorPercentDisplay || ""}
          </TableCell>
          <TableCell>
            {getLabelOfAppearanceType(
              productDetail?.dimensionWeight
                ?.appearanceSelect as DemensionAndWeightAppearanceTypeEnum,
            )}
          </TableCell>
          <TableCell sx={{ maxWidth: "200px" }}>
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              {productDetail?.dimensionWeight?.appearanceText || ""}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              {getLabelOfOthersStandard(
                productDetail?.dimensionWeight
                  ?.otherStandardSelect as InspectionOtherStandard,
              )}
            </Typography>
          </TableCell>
          <TableCell sx={{ maxWidth: "200px" }}>
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              {productDetail?.dimensionWeight?.otherStandardText || ""}
            </Typography>
          </TableCell>

          <TableCell sx={{ maxWidth: "200px" }}>
            {productDetail?.dimensionWeight?.foldingStandardSize || ""}
          </TableCell>

          <TableCell sx={{ maxWidth: "200px" }}>
            {productDetail?.dimensionWeight?.foldingStandardCount || ""}
          </TableCell>
        </TableRow>
      </TableBody>
    </XTablePagination>
  );
});
